"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _DeviceOther = _interopRequireDefault(require("@rsuite/icon-font/lib/device/DeviceOther"));

// Generated by script, don't edit it please.
var DeviceOther = (0, _createSvgIcon["default"])({
  as: _DeviceOther["default"],
  ariaLabel: 'device other',
  category: 'device',
  displayName: 'DeviceOther'
});
var _default = DeviceOther;
exports["default"] = _default;
module.exports = exports.default;